import { useState, useEffect, useCallback, useMemo } from "react";
import type { BlockConfig } from "@/lib/registry/types";
// Remove unused Item type import
// import type { Item } from "./component-card";

// Define item type matching the one used in isotope-grid/component-card
// Remove unused Item type definition
// export type Item = BlockConfig & {
//   id: string;
//   library?: string;
//   name: string;
//   description?: string;
//   categories?: string[];
//   tags?: string[];
//   previewProps?: {
//     previewPath: string;
//     hasPreviewImage: boolean;
//     availablePreviewFiles: string[];
//     demoFiles?: string[];
//   };
// };

// Use BlockConfig directly
export function useStarredItems(initialItems: (BlockConfig & { id: string })[]) {
    const [starredItemsSet, setStarredItems] = useState<Set<string>>(() => {
        if (typeof window === "undefined") return new Set();
        try {
            const saved = localStorage.getItem("starredComponents");
            return saved ? new Set(JSON.parse(saved) as string[]) : new Set();
        } catch (error) {
            console.error("Failed to parse starred components from localStorage:", error);
            return new Set(); // Fallback to empty set on error
        }
    });

    // Persist starred items to localStorage whenever the set changes
    useEffect(() => {
        if (typeof window !== "undefined") {
            try {
                localStorage.setItem(
                    "starredComponents",
                    JSON.stringify(Array.from(starredItemsSet))
                );
            } catch (error) {
                console.error("Failed to save starred components to localStorage:", error);
            }
        }
    }, [starredItemsSet]);

    // Function to toggle the starred status of an item by its ID
    const toggleStar = useCallback((id: string) => {
        setStarredItems((prev) => {
            const next = new Set(prev); // Create a mutable copy
            if (next.has(id)) {
                next.delete(id); // Unstar
            } else {
                next.add(id); // Star
            }
            return next; // Return the new set
        });
    }, []); // No dependencies needed, function is stable

    // Function to check if an item is starred by its ID
    const isStarred = useCallback(
        (id: string) => starredItemsSet.has(id),
        [starredItemsSet] // Recreate check function only if the set changes
    );

    return { toggleStar, isStarred, starredItemsSet };
}
